(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["palmr-hat-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    document.querySelectorAll('[data-palmr-hat-offer]').forEach(function (box) {
      if (box.dataset.offerInitialized) return;
      var reward = document.querySelector('[data-palmr-cd-reward]');
      if (!reward || reward.getAttribute('data-hat-offer-enable') !== 'true') return;
      var tier = box.getAttribute('data-offer-tier');
      var isT2 = tier === '2';
      var copy = box.getAttribute('data-offer-copy') || reward.getAttribute(isT2 ? 'data-polo-offer-text' : 'data-hat-offer-text');
      var amount = parseInt(reward.getAttribute('data-tier' + tier), 10) || 0;
      var unit = parseInt(box.getAttribute('data-unit-price'), 10) || 0;
      if (!copy || !amount || !unit || unit * 2 < amount) return;
      box.dataset.offerInitialized = 'true';
      box.querySelector('[data-palmr-hat-offer-text]').textContent = copy;
      var thresholds = box.querySelector('[data-palmr-hat-offer-thresholds]');
      if (thresholds && window.PalmrGifts && window.PalmrGifts.money) {
        var shipping = parseInt(reward.getAttribute('data-shipping'), 10) || 0;
        var parts = [];
        if (shipping) parts.push(thresholds.dataset.shippingLabel + ' ' + window.PalmrGifts.money(shipping));
        parts.push(thresholds.dataset.giftLabel + ' ' + window.PalmrGifts.money(amount));
        thresholds.textContent = parts.join(' · ');
        var second = box.querySelector('[data-palmr-hat-offer-second]');
        var tier2 = parseInt(reward.getAttribute('data-tier2'), 10) || 0;
        if (second && tier2) second.textContent = second.dataset.label + ' ' + window.PalmrGifts.money(tier2) + '.';
        else if (second) second.remove();
      }
      box.removeAttribute('hidden');
      if (reward.getAttribute('data-gift-thumbs-enable') !== 'true' || !window.PalmrGifts) return;
      var handle = reward.getAttribute(isT2 ? 'data-tier2-collection' : 'data-tier1-collection');
      if (!handle) return;
      function paint(list) {
        if (!list || !list.length) return;
        var sorted = list.slice().sort(function (a, b) { return (b.price || 0) - (a.price || 0); });
        var thumbs = box.querySelector('[data-palmr-hat-offer-thumbs]');
        var rows = box.querySelector('[data-palmr-hat-offer-list]');
        sorted.forEach(function (gift, index) {
          var row = document.createElement('li');
          if (gift.image) {
            var img = document.createElement('img');
            img.src = gift.image;
            img.alt = '';
            img.width = 48;
            img.height = 48;
            img.decoding = 'async';
            if (index < 3) {
              var thumb = img.cloneNode();
              thumb.width = 32;
              thumb.height = 32;
              thumbs.appendChild(thumb);
            }
            img.loading = 'lazy';
            row.appendChild(img);
          }
          var name = document.createElement('span');
          name.textContent = gift.name || '';
          row.appendChild(name);
          rows.appendChild(row);
        });
        if (sorted.length > 3) {
          var more = box.querySelector('[data-palmr-hat-offer-more]');
          more.textContent = '+' + (sorted.length - 3) + ' ' + box.dataset.moreLabel;
          more.removeAttribute('hidden');
        }
        box.querySelector('[data-palmr-hat-offer-gifts]').removeAttribute('hidden');
      }
      function go() { window.PalmrGifts.load(handle).then(paint).catch(function () {}); }
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2000 });
      else window.setTimeout(go, 300);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmr-purchase-note"] && !Shopify.designMode) return;
  try {
    if (!window.palmrSignupBound) {
    window.palmrSignupBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-palmr-signup]');
      if (!button) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', button.dataset.palmrSignup]);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
